import React from 'react';
import { Box, Typography, useTheme } from '@ublend-npm/aulaui-core';
import { getStarredSpaceColors } from '../../colors';

const STRINGS = {
  title: 'No recently viewed spaces',
  subtitle: 'Spaces you open will show here.',
};

const RecentlyViewedSpacesEmptyState: React.FC = () => {
  const { palette } = useTheme();
  const colors = getStarredSpaceColors(palette);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      bgcolor={colors.emptyPanelBg}
      borderRadius="0.5rem"
      px={{ xs: 2, md: 3 }}
      pt={{ xs: 2, md: 3 }}
      pb="16px"
      flex={1}
      width="100%"
      minHeight="200px"
      sx={{
        transition: 'background-color 0.2s',
      }}
      role="status"
      aria-label="No recently viewed spaces empty state"
    >
      <Typography
        color="text.primary"
        sx={{
          fontFamily: (theme) => theme.typography.fontFamily,
          fontWeight: 'regular',
          fontStyle: 'normal',
          fontSize: '1rem',
          lineHeight: '175%',
          letterSpacing: '0.15px',
          textAlign: 'center',
        }}
      >
        {STRINGS.title}
      </Typography>

      <Typography
        mt="-4px"
        color="text.secondary"
        sx={{
          fontFamily: (theme) => theme.typography.fontFamily,
          fontWeight: 'regular',
          fontStyle: 'normal',
          fontSize: '0.875rem',
          lineHeight: '143%',
          letterSpacing: '0.17px',
          textAlign: 'center',
        }}
      >
        {STRINGS.subtitle}
      </Typography>
    </Box>
  );
};

export default RecentlyViewedSpacesEmptyState;
